import * as angular from "angular";
import * as _ from "lodash";

import {IController} from "angular";

export class PlanningProjectItemCtrl implements IController {

  project: any;
  draft: any;
  onSelect: Function;
  onDelete: Function;

  /* @ngInject */
  constructor(private $state, private planningConstants, private $window) {
  }

  onSelectProject() {
    this.onSelect({project: this.project})
  }

  onGoToProject() {
    if (_.get(this.project, 'status') === 'DISPATCHED') {
      this.$state.go(this.planningConstants.states.completed, {
        projectId: this.project.id,
        draftId: this.project.selectedDraftId
      }, {notify: true, reload: false});
    } else if (_.get(this.project, 'selectedDraftId')) {
      this.$state.go(this.planningConstants.states.draft, {
        projectId: this.project.id,
        draftId: this.project.selectedDraftId
      }, {notify: true, reload: false});
    } else {
      this.$state.go(this.planningConstants.states.project, {
        projectId: this.project.id,
        draftId: undefined
      }, {notify: true, reload: false});
    }
  }

  onOpenInNewTab() {
    const url = this.getProjectUrl();
    this.$window.open(url, '_blank');
  }

  private getProjectUrl() {
    if (_.get(this.project, 'status') === 'DISPATCHED') {
      return this.$state.href(this.planningConstants.states.completed, {
        projectId: this.project.id,
        draftId: this.project.selectedDraftId
      });
    } else if (_.get(this.project, 'selectedDraftId')) {
      return this.$state.href(this.planningConstants.states.draft, {
        projectId: this.project.id,
        draftId: this.project.selectedDraftId
      });
    } else {
      return this.$state.href(this.planningConstants.states.project, {
        projectId: this.project.id,
        draftId: undefined
      });
    }
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningProjectItem', {
    bindings: {
      project: '<',
      draft: '<',
      onSelect: '&',
      onDelete: '&'
    },
    template: require('./planning-project-item.html').default,
    controller: PlanningProjectItemCtrl
  });
